import { useState, useEffect, createContext, useContext } from 'react'
import PropTypes from 'prop-types'

const SnackbarContext = createContext()

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({ isOpen: false, message: '', isError: false })

  const displaySnackbar = (message, isError = false) => {
    setSnackbar({ isOpen: true, message, isError })
  }

  useEffect(() => {
    let timeoutId

    if (snackbar.isOpen) {
      timeoutId = setTimeout(() => {
        setSnackbar((prevState) => ({ ...prevState, isOpen: false }))
      }, 3000)
    }

    return () => clearTimeout(timeoutId)
  }, [snackbar.isOpen])

  return (
    <SnackbarContext.Provider value={{ snackbar, displaySnackbar }}>
      {children}
    </SnackbarContext.Provider>
  )
}

export const useSnackbar = () => {
  const context = useContext(SnackbarContext)
  if (context === undefined) {
    throw new Error('useSnackbar() must be used within SnackbarProvider.')
  }
  return context
}

SnackbarProvider.propTypes = {
  children: PropTypes.node,
}
